<!-- eslint-disable max-lines -->
<template>
    <div class="file-detail-subtab customer-subtab">
        <div class="file-detail-btn">
            <lots-button type="text" v-show="!currentRoleLoading && addPaperShow" icon="el-icon-circle-check" size="medium" v-has="authorityCode.addPaper"
                @click="addPaper">生成一页纸</lots-button>
            <UploadBtn
                v-show="!currentRoleLoading && addPaperShow"
                style="margin-left: 10px;"
                bucket="annto-lcrm"
                accept=".doc,.docx"
                :needBtn="false"
                :before-upload="beforeUpload"
                @callback="handleUpload"
            >
                <lots-button type="text" icon="el-icon-upload2" size="medium" :loading="isUploadLoading">上传</lots-button>
            </UploadBtn>
            <span class="tips-color" v-show="!currentRoleLoading &&!addPaperShow">{{ addPaperShowText }}</span>
        </div>
        <div class="file-detail-table">
            <edit-table-box class="prescreen" v-loading="subTabTable.tableLoading" ref="editTableBox" :rowEdit="true"
                :selection="config.selection" :control="true" :columns="newColumns" :height="tableHeight"
                :tableData="subTabTable.totalData" :actions="config.actions" :editDisableRule="editDisableRule"
                :allowRowClick="false" @selection-change="handleSelectedRow" @btn-event="actionClick">
                    <template v-slot:col-append="{item, row, rIndex}">
                        <span v-if="item.prop ==='pageName'" class="paper-file-name" @click="openChangeTitle(row)">
                            {{row[item.prop]}}
                        </span>
                        <div v-if="item.prop ==='fileName'">
                            <el-popover
                                placement="left"
                                width="80"
                                popper-class="file-name-poper"
                                trigger="hover"
                            >
                                <span class="poper-do-list">
                                    <span v-if="isShowEditRow(row)" @click="openHtmlAction(row,rIndex)">修改</span>
                                    <span @click="handlePreview(row)">查看</span>
                                    <span @click="openFileNameDialog(row,rIndex)">下载</span>
                                    <span v-if="isShowEditRow(row)" @click="handlePreview(row, true)">分享</span>
                                </span>
                                <span  slot="reference" class="paper-file-name" @click="openPopver(row,rIndex)" >
                                    {{row[item.prop]}}
                                </span>
                            </el-popover>
                        </div>

                        <span v-if="['customerGroupCode','pageStatus'].includes(item.prop)" >
                            {{ codesToNames(row[item.prop],
                            dictDatas[item.optionsKey]) }}
                        </span>

                </template>
                <template v-slot:edit-col-append="{item, row, rIndex}">
                    <el-input
                        size="mini"
                        v-model="row[item.prop]"
                        placeholder="请输入"
                        v-if="item.prop ==='pageName'">
                    </el-input>
                    <el-popover
                            placement="left"
                            width="80"
                            popper-class="file-name-poper"
                            trigger="hover"
                            >
                            <span class="poper-do-list">
                                <span v-if="isShowEditRow(row)" @click="openHtmlAction(row)">修改</span>
                                <span @click="handlePreview(row)">查看</span>
                                <span @click="openFileNameDialog(row,rIndex)">下载</span>
                                <span v-if="isShowEditRow(row)" @click="handlePreview(row, true)">分享</span>
                            </span>
                            <span v-if="item.prop ==='fileName'" slot="reference" class="paper-file-name" >
                                {{row[item.prop]}}
                            </span>
                        </el-popover>
                    <span v-if="item.prop ==='customerGroupCode'" >
                        {{ codesToNames(row[item.prop],
                        dictDatas[item.optionsKey]) }}
                    </span>
                    <span v-if="item.prop ==='pageStatus'">
                        <lots-select
                            v-model="row[item.prop]"
                            :disabled="['1','2'].includes(row['oldPageStatus'])"
                            :options="dictDatas[item.optionsKey]"
                            :placeholder="'请选择'"
                            >
                        </lots-select>

                    </span>

                </template>
            </edit-table-box>
            <div class="footer">
                <lots-pagination @size-change="subTabTable.sizeChange" :current-page.sync="subTabTable.pageNo"
                    @current-change="subTabTable.pageChange" size="small"
                    layout="total, sizes, prev, pager, next, jumper" :total="subTabTable.pageTotal" />
            </div>
        </div>
        <add-paper ref="addPrperRef" title="客户一页纸名称" width="600px"  @savePaper="savePaper" />
        <down-file-dialog ref="downRef" :detailData="detailData"  />
        <!-- 一页纸编辑页面 -->
        <PaperDialog ref="paperDialogRef" :managerRole="currentRole.admin" :customerFormDetail="detailData" @updateList="subTabTable.getList()" />
    </div>
</template>

<script>
import { ref, reactive, computed, watch, onMounted } from '@vue/composition-api';
import editTableBox from '@/components/lots/editTableBox/Index';
import lotsSelect from '@/components/lots/lotsSelect/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import lotsButton from '@/components/lots/lotsButton';
import UploadBtn from '@/components/lots/oss/UploadBtn.vue';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { tableConfig } from './config.js';
import mConfig from '@/config/user.env';
import { Message, MessageBox } from 'element-ui';
import { STATE_OTHER_CHANGE } from '@/modules/mdm/constant/contractManage.js';
import addPaper from './component/addPaperDialog/Index.vue';
import downFileDialog from './component/downFileDialog/Index.vue';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import PaperDialog from '../paperDialog/Index.vue';
import utils from '@/components/utils/common.js';
import store from '@/store/index';
import { filePreview } from '@/utils/filePreview.js';
import {
    getCustomeOnePageList,
    saveCustomeOnePage,
    queryOnePageEnableEditRole,
    deleteBatchCustomeOnePage,
    updateStatusCustomeOnePage,
    analysisCustomeOnePage
} from '@mdm/api/customer/customerManage.js';
import _ from 'lodash';
export default {
    name: 'customerPaper',
    components: {
        lotsPagination,
        lotsButton,
        UploadBtn,
        lotsSelect,
        editTableBox,
        addPaper,
        downFileDialog,
        PaperDialog
    },
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailData: {
            type: Object,
            return: () => { }
        },
        tableHeight: {
            type: Number,
            default: 325
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.customerManage);
        // const refs = setupContext.refs;
        const config = reactive(_.cloneDeep(tableConfig));
        const { userCode } = store.getters.user;
        const isDisableBtn = ref(false);
        const saveLoading = ref(false);
        const fileVisible = ref({});
        class FilesDetailClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.ebcuId = props.detailData.ebcuId;
                condition.customerGroupCode = props.detailData.customerGroupCode;
                return condition;
            };
            afterGetList(res) {
                if (+res.code === 0) {
                    res.data.list.forEach(item => {
                        item.edit = -3;
                        item.allowEdit = item.id;
                        item.managerRole = currentRole.value.admin;
                        item.pageStatus = item.pageStatus?.toString();
                        if (item.pageStatus === '0' && !currentRole.value.admin && userCode !== item.createUserCode) {
                            item.fileName = null;
                        }
                        item.oldPageStatus = item.pageStatus?.toString();
                        item.customerGroupCode = item.customerGroupCode?.toString();
                    });
                    this.totalData.value = res.data.list;
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }
        const subTabTable = new FilesDetailClass({
            Api: {
                listApi: getCustomeOnePageList
            }
        });
        const newColumns = computed(() => {
            return config.columns;
        });
        const addPaperShow = computed(() => {
            if (['00', '', null, undefined].includes(props.detailData.customerGroupCode)) {
                return false;
            }
            return currentRole.value.admin || currentRole.value.hasCustomerGroupCode;
        });
        const addPaperShowText = computed(() => {
            if (['00', '', null, undefined].includes(props.detailData.customerGroupCode)) {
                return '该客户暂不支持生成一页纸。';
            }
            return currentRole.value.admin || currentRole.value.hasCustomerGroupCode ? '' : '当前用户缺少该客户系权限，请申请后再查看。';
        });

        const selections = ref([]); // 选中的行数组
        const handleSelectedRow = (selection) => {
            selections.value = selection;
        };
        const sealAdminKey = ref(false);
        const openLink = () => {
            window.open(mConfig.mSign, '_blank');
        };
        const customerRow = ref({});
        const addPaper = () => {
            customerRow.value = {};
            setupContext.refs.addPrperRef.show({
                pageName: `${props.detailData.customerName}一页纸${utils.formatDateTime(new Date(), 'YYYYMMDD')}${padZero(subTabTable.pageTotal.value + 1)}`
            });
        };
        // 数字补零
        const padZero = (num, targetLength = 2) => {
            return num.toString().padStart(targetLength, '0');
        };
        const isUploadLoading = ref(false);
        // 上传前
        const beforeUpload = (file) => {
            const extension = file.name.split('.').pop(); // 获取文件扩展名
            const isWord = ['doc', 'docx'].includes(extension);
            if (!isWord) {
                Message.warning('只能上传 Word 文档！');
                return false; // 阻止文件上传
            }
            isUploadLoading.value = true;
            return true; // 允许文件上传
        };
        // 上传
        const handleUpload = (file) => {
            isUploadLoading.value = false;
            if (file && +file.code === 0) {
                const { data } = file;
                const params = {
                    pageName: `${props.detailData.customerName}一页纸${utils.formatDateTime(new Date(), 'YYYYMMDD')}${padZero(subTabTable.pageTotal.value + 1)}`,
                    pageStatus: '1',
                    customerGroupName: props.detailData.customerGroupName,
                    customerGroupCode: props.detailData.customerGroupCode,
                    customerManager: props.detailData.customerOwnerCode,
                    customerManagerName: props.detailData.customerOwnerName,
                    customerName: props.detailData.customerName,
                    customerCode: props.detailData.customerCode,
                    title: props.detailData.customerGroupName + '合作介绍',
                    origDocName: data.name,
                    origDocUrl: data.downUrl
                };
                analysisCustomeOnePage(params).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('上传成功');
                        subTabTable.getList();
                    }
                });
            }
        };
        const actionClick = (row, event, index) => {
            switch (event) {
            case 'save': // 保存
                saveAction(row);
                break;
            case 'abandon': // 废弃
                abandonAction({ id: row.id, pageStatus: '2' });
                break;
            case 'delete': // 删除
                delAction(row);
                break;
            case 'reboot': // 废弃重启
                abandonAction({ id: row.id, pageStatus: '1' });
                break;
            }
        };
        const saveAction = (row) => {
            savePaper(row, true);
        };
        const openChangeTitle = (row) => {
            setupContext.refs.paperDialogRef.show({
                customerGroupName: props.detailData.customerGroupName,
                customerGroupCode: props.detailData.customerGroupCode,
                customerManager: props.detailData.customerOwnerCode,
                customerManagerName: props.detailData.customerOwnerName,
                customerName: props.detailData.customerName,
                customerCode: props.detailData.customerCode,
                pageName: row.pageName,
                id: row.id,
                total: padZero(subTabTable.pageTotal.value + 1)
            });
            // customerRow.value = row;
            // setupContext.refs.addPrperRef.show(row);
        };
        // 删除
        const delAction = (row) => {
            MessageBox.confirm('删除后的一页纸不可恢复，请确认！', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { code } = await deleteBatchCustomeOnePage([row.id]);
                if (+code === 0) {
                    subTabTable.getList();
                    Message.success('删除成功');
                }
            });
        };
        // 废弃/废弃重启
        const abandonAction = async (data) => {
            const { code } = await updateStatusCustomeOnePage(data);
            if (+code === 0) {
                subTabTable.getList();
                Message.success('操作成功');
            }
        };
        const openHtmlAction = (row, rIndex) => {
            // 打开html编辑
            if (!_.isNil(rIndex)) {
                fileVisible.value['file' + rIndex] = false;
            }
            setupContext.refs.paperDialogRef.show({
                customerGroupName: props.detailData.customerGroupName,
                customerGroupCode: props.detailData.customerGroupCode,
                customerManager: props.detailData.customerOwnerCode,
                customerManagerName: props.detailData.customerOwnerName,
                customerName: props.detailData.customerName,
                customerCode: props.detailData.customerCode,
                pageName: row.pageName,
                id: row.id,
                total: padZero(subTabTable.pageTotal.value + 1)
            });
        };
        const savePaper = (val, noOpenHtml = false) => {
            // 打开html编辑
            const params = {
                ...customerRow.value,
                customerManager: props.detailData.customerOwnerCode,
                customerManagerName: props.detailData.customerOwnerName,
                customerGroupCode: props.detailData.customerGroupCode,
                pageName: val.pageName,
                versionCode: val.versionCode
            };
            if (noOpenHtml) {
                params.id = val.id;
                params.pageStatus = Number(val.pageStatus);
            }
            if (!params.pageName) {
                return Message.warning('一页纸名称不能为空');
            }
            saveCustomeOnePage(params).then(res => {
                if (res && +res.code === 0) {
                    setupContext.refs.addPrperRef.closeVisible(false);
                    Message({
                        type: 'success',
                        message: '保存成功',
                        customClass: 'paper-success'
                    });
                    !noOpenHtml && setupContext.refs.paperDialogRef.show({
                        customerGroupName: props.detailData.customerGroupName,
                        customerGroupCode: props.detailData.customerGroupCode,
                        customerManager: props.detailData.customerOwnerCode,
                        customerManagerName: props.detailData.customerOwnerName,
                        customerName: props.detailData.customerName,
                        customerCode: props.detailData.customerCode,
                        pageName: params.pageName,
                        id: res.data.id,
                        total: padZero(subTabTable.pageTotal.value + 2)
                    }, 'add');
                    subTabTable.getList();
                }
            });
        };
        const openFileNameDialog = (row, rIndex) => {
            fileVisible.value['file' + rIndex] = false;
            setupContext.refs.downRef.show(row);
        };
        // 查看/分享
        const handlePreview = (row, flag = false) => {
            if (!row.docUrl && !row.pdfUrl) {
                return Message.warning('当前无文档可预览');
            }
            filePreview({
                fileUrl: row.docUrl || row.pdfUrl,
                fileName: row.fileName
            }, flag ? handleShare : null);
        };
        // 分享
        const handleShare = (url) => {
            navigator.clipboard.writeText(url)
                .then(() => {
                    Message.success('复制成功');
                })
                .catch((err) => {
                    console.error('Failed to copy text: ', err);
                });
        };
        const openPopver = (row, rIndex) => {
            if (fileVisible.value['file' + rIndex]) {
                fileVisible.value['file' + rIndex] = false;
                return false;
            }
            fileVisible.value['file' + rIndex] = true;
        };
        // const abandonAction = () => {
        //     const params = {
        //         id: row.id
        //     };
        //     xxx(params).then(res => {
        //         if (res && +res.code === 0) {
        //             Message.success('废弃成功');
        //         }
        //     });
        // };
        const editDisableRule = row => {
            // 管理员可编辑
            if (['2'].includes(row.pageStatus?.toString())) {
                return true;
            }
            return !(row.managerRole || (row.createUserCode === userCode));
        };
        const isShowEditRow = (row) => {
            if (['2'].includes(row.pageStatus?.toString())) {
                return false;
            }
            return row.managerRole || (row.createUserCode === userCode);
        };
        const currentRole = ref({});
        const currentRoleLoading = ref(false);
        const getManagerRole = () => {
            if (!props.detailData.customerGroupCode) {
                currentRole.value = {};
                return;
            }
            currentRoleLoading.value = true;
            return queryOnePageEnableEditRole({ userCode: userCode, customerGroupCode: props.detailData.customerGroupCode }).then(res => {
                if (res && +res.code === 0) {
                    currentRole.value = res.data;
                } else {
                    currentRole.value = {};
                }
                currentRoleLoading.value = false;
            }).finally(() => {
                currentRoleLoading.value = false;
            });
        };
        const dictDatas = ref({});
        onMounted(async () => {
            dictDatas.value = await otherUtils.getDictDataList(newColumns.value);
        });
        watch(
            () => [props.activeName, props.detailData],
            // eslint-disable-next-line complexity
            async (newVal) => {
                if (newVal[0] === 'paper') {
                    await getManagerRole();
                    if (newVal[0]) {
                        newVal[1].ebcuId && newVal[1].customerGroupCode && subTabTable.getList();
                    } else {
                        subTabTable.totalData.value = [];
                        subTabTable.pageTotal.value = 0;
                    }
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            config,
            subTabTable,
            isDisableBtn,
            saveLoading,
            authorityCode,
            STATE_OTHER_CHANGE,
            newColumns,
            sealAdminKey,
            dictDatas,
            codesToNames: otherUtils.codesToNames,
            customerRow,
            fileVisible,
            currentRole,
            addPaperShow,
            addPaperShowText,
            currentRoleLoading,
            isUploadLoading,
            openPopver,
            editDisableRule,
            isShowEditRow,
            openHtmlAction,
            openFileNameDialog,
            handlePreview,
            savePaper,
            openChangeTitle,
            handleSelectedRow,
            openLink,
            addPaper,
            beforeUpload,
            handleUpload,
            actionClick
        };
    }
};
</script>

<style lang="less" scoped>
.tips-color{
    padding-bottom: 8px;
    color: #888;
}
.customer-subtab {
    .file-detail-btn {
        width: 100%;
        display: flex;
        align-items: center;
    }

    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
}
.paper-file-name{
    color: #4285f5;
    cursor: pointer;
}
</style>
<style lang="less">
.file-name-poper{
    min-width: 80px!important;
    padding: 0;
    .poper-do-list{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 3px 0;
        span{
            padding: 3px 0;
            color: #4285f5;
            cursor: pointer;
        }
    }
}
.paper-success{
    z-index: 3001!important;
}
</style>
